export default "__VITE_ASSET__6qJZVxDd__"